import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { OPTIES, waLink } from "@/data/site";
import CTASection from "@/components/CTASection";

const Opties = () => {
  return (
    <>
      {/* Hero */}
      <section className="bg-ink text-white pt-40 pb-24 md:pt-48 md:pb-32 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.07] pointer-events-none"
          style={{ backgroundImage: "radial-gradient(circle at 70% 30%, #C89B5C 0%, transparent 55%)" }}
        />
        <div className="container-x relative max-w-3xl">
          <p className="eyebrow text-gold mb-4">{OPTIES.eyebrow}</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.03]">
            Opties voor <span className="italic text-gold">elke shoot</span>
          </h1>
          <p className="mt-6 text-white/75 text-base leading-relaxed max-w-2xl">
            {OPTIES.intro}
          </p>
        </div>
      </section>

      {/* Option groups */}
      <section className="bg-beige py-24 md:py-32">
        <div className="container-x grid grid-cols-1 md:grid-cols-3 gap-8">
          {OPTIES.groups.map((group, gi) => (
            <motion.div
              key={group.title}
              data-testid={`opties-group-${gi}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: gi * 0.1 }}
              className="bg-white border border-neutral-200 p-8 md:p-10"
            >
              <h2 className="font-serif text-2xl md:text-3xl mb-6">{group.title}</h2>
              <ul className="divide-y divide-neutral-200 border-t border-neutral-200">
                {group.items.map((item) => (
                  <li key={item.name} className="flex items-center justify-between gap-4 py-4">
                    <span className="flex items-start gap-2 text-neutral-800 text-sm">
                      <Plus size={15} strokeWidth={2.5} className="text-gold mt-0.5 shrink-0" />
                      {item.name}
                    </span>
                    <span className="font-serif text-lg text-gold whitespace-nowrap">{item.price}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
        <div className="container-x mt-14 text-center">
          <p className="text-sm text-neutral-600 italic max-w-2xl mx-auto">{OPTIES.note}</p>
          <a
            data-testid="opties-contact-btn"
            href={waLink("Hallo Eric, ik heb een vraag over de extra opties.")}
            target="_blank"
            rel="noreferrer"
            className="btn-gold mt-8 inline-block"
          >
            Vraag een offerte op maat
          </a>
        </div>
      </section>

      <CTASection />
    </>
  );
};

export default Opties;
